import IconPlusBig from '@icons/PlusBig'
import { useEffect, useState } from 'react'
import * as S from './ReadMoreReadLess.styled'
import TruncatedElement from './TruncatedElement'

const isCssEllipsisApplied = (elem) => elem.scrollHeight > elem.clientHeight

const ReadMoreReadLess = ({
  isReactComponent,
  content,
  lines = 5,
  maxLines = 1000,
  withToggle = true,
  onShowMore = () => {},
}) => {
  const [sLines, setLines] = useState(lines)
  const [isExpanded, setIsExpanded] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const handleToggleShowMore = (show) => {
    const newLines = show ? maxLines : lines

    setShowMore((showMore) => !showMore)
    setIsExpanded((isExpanded) => !isExpanded)
    setLines(newLines)

    onShowMore(show)
  }

  const handleConfigElement = (elem) => {
    if (!elem) return

    if (isCssEllipsisApplied(elem)) {
      if (withToggle && !showMore && !isExpanded) {
        setShowMore(true)
      }
    } else {
      elem.removeAttribute('title')
      setShowMore(false)
    }
  }

  useEffect(() => {
    if (lines) {
      setLines(lines)
    }
  }, [lines])

  return (
    <S.ContentWrap className='readmore-readless'>
      <TruncatedElement lines={sLines} getRef={handleConfigElement}>
        <S.Content>
          {isReactComponent ? (
            content
          ) : (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          )}
        </S.Content>
      </TruncatedElement>

      {showMore && !isExpanded && (
        <S.ReadMoreLessButton onClick={() => handleToggleShowMore(true)}>
          Read more <IconPlusBig />
        </S.ReadMoreLessButton>
      )}

      {isExpanded && (
        <S.ReadMoreLessButton onClick={() => handleToggleShowMore(false)}>
          Read less <IconPlusBig />
        </S.ReadMoreLessButton>
      )}
    </S.ContentWrap>
  )
}

export default ReadMoreReadLess
